import React from "react";

const ScoreCard = ({ title, value }) => {
  return (
    <div className="flex flex-row text-[11px] text-[#9d9d9d] items-center justify-between">
      <span className="">{title}</span>
      <h2 className={`font-bold`}>{value} pts</h2>
    </div>
  );
};
export default ScoreCard;
